import { render } from "./MyWarnings.vue?vue&type=template&id=a0a6c7a4&scoped=true"
import script from "./MyWarnings.vue?vue&type=script&lang=js"
export * from "./MyWarnings.vue?vue&type=script&lang=js"

import "./MyWarnings.vue?vue&type=style&index=0&id=a0a6c7a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a6c7a4"]])

export default __exports__